"use client";
import { useState } from "react";
import {sendForm} from "@/app/services/FormService";
import {isEmpty, isValidEmail} from "@/app/utils/Validations";
import {FormattedMessage} from "react-intl";
import styles from "@/app/styles/components/pages/contact/contact-page-form.module.scss";

const ContactPageForm = () => {
    const [data, setData] = useState({})
    const [errors, setErrors] = useState({});
    const [messageText, setMessageText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [messageSent, setMessageSent] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const formId = '684';

    const resetForm = () => {
        setData({
            name: "",
            email: "",
            phone: "",
            message: ""
        });
        setErrors({});
    }

    const handleChange = (name, value) => {
        setData({
            ...data,
            [name]: value
        })
    }

   const getFormErrors = () => {

        let formErrors = {}

        if (isEmpty(data?.name)) {
            formErrors.name = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }
       
        if (!isValidEmail(data?.email)) {
            formErrors.email = <FormattedMessage id={'common.errors.emailIsNotValid'}/>
        }

        if (isEmpty(data?.phone)) {
            formErrors.phone = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }

        if (isEmpty(data?.message)) {
            formErrors.message = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }
       
        return formErrors
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessageText('')
        const formErrors = getFormErrors()

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }

        setIsLoading(true);
        let formData = new FormData();
        formData.append("your-name", data.name);
        formData.append("your-email", data.email);
        formData.append("your-phone", data.phone);
        formData.append("your-message", data.message);
        formData.append("_wpcf7_unit_tag", "wpcf7-f68548c3-1");

        sendForm(formId, formData)
            .then(response => {
                setData({})
                setIsLoading(false);
                setMessageText(response.message);
                resetForm();
                setMessageSent(true);
            })
            .catch(error => {
                setIsLoading(false);
                setFormErrorMessage(common.sendError);
                setMessageSent(false);
            })
    }

    return (
        <div className={styles.contactForm}>
            <form onSubmit={handleSubmit} className="formStyle">
                 <div className="inputContainer">
                    <FormattedMessage id={'components.pages.contact.contactPageForm.name'}>
                        {(message) =>
                            <input
                                id="name-input-contact"
                                type="text"
                                value={data.name}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChange('name', e.target.value)}
                            />
                            }
                    </FormattedMessage>
                    {errors?.name && <div className="errorMessage">{errors?.name}</div>}
                </div>
                <div className="inputContainer">
                    <FormattedMessage id={'components.pages.contact.contactPageForm.email'}>
                        {(message) =>
                            <input
                                id="email-input-contact"
                                type="email"
                                value={data.email}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChange('email', e.target.value)}
                            />
                        }
                    </FormattedMessage>
                    {errors?.email && <div className="errorMessage">{errors?.email}</div>}
                </div>
                <div className="inputContainer">
                    <FormattedMessage id={'components.pages.contact.contactPageForm.phone'}>
                        {(message) =>
                            <input
                                id="phone-input-contact"
                                type="tel"
                                value={data.phone}
                                placeholder={message}
                                onChange={(e) => handleChange('phone', e.target.value)}
                            />
                        }
                    </FormattedMessage>
                    {errors?.phone && <div className="errorMessage">{errors?.phone}</div>}
                </div>
                <div className="inputContainer">
                    <FormattedMessage id={'components.pages.contact.contactPageForm.message'}>
                        {(message) =>
                            <textarea
                                id="messsage-contact"
                                value={data.message}
                                placeholder={message}
                                onChange={(e) => handleChange('message', e.target.value)}
                            />
                        }
                    </FormattedMessage>
                    {errors?.message && <div className="errorMessage">{errors?.message}</div>}
                </div>
                <div className="buttonContainer">
                    <button className="submit-btn btnGlobal"><FormattedMessage id={'common.send'}/></button>
                </div>
                {isLoading && <div className="sending"><FormattedMessage id={'common.sending'}/></div>}
                {messageSent && <div className="success-message">{messageText}</div>}
                {formErrorMessage && <div className="error-message-2">{formErrorMessage}</div>}
            </form>
        </div>
    )
}

export default ContactPageForm;
